// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__hI6Dd","icon":"SearchBar_icon__EfDZn","clear":"SearchBar_clear__F2A6Z","open":"SearchBar_open__GCR-Z"};